export enum TokenType {
	unknown = 0,
	forgotPassword = 1,
	userActivation = 2,
	changePassword = 3,
}
